import { AnimationEvent, usePopup } from '@libs/hooks';
import { TBottomSheetProps, TModalWindow } from '@libs/types';
import { ConditionalRender } from '@libs/utils';
import clsx from 'clsx';
import React from 'react';
import styles from './bottomSheet.module.css';

type TFullScreenBottomSheetProps = {
    widgetId?: string;
    animatedClose?: boolean;
    isTop: boolean;
    bottomSheet?: TModalWindow;
    closeAnimationPopup: (e: AnimationEvent<HTMLDivElement>) => void;
    setAnimatedClose: () => void;
    modal: React.ReactNode | null;
    WidgetsList: TBottomSheetProps['WidgetsList'];
};
const FullScreenBottomSheet = ({
    widgetId,
    animatedClose,
    isTop,
    closeAnimationPopup,
    setAnimatedClose,
    modal,
    bottomSheet,
    WidgetsList,
}: TFullScreenBottomSheetProps) => {
    usePopup(isTop ? widgetId : undefined, setAnimatedClose, modal);
    return (
        <ConditionalRender condition={!!bottomSheet}>
            <div
                id={`bsForFullScreen-${widgetId}`}
                className={clsx(styles.fullScreen, animatedClose ? styles.closeAnimationName : styles.openAnimationName)}
                onAnimationEnd={(e) => {
                    if (animatedClose) {
                        closeAnimationPopup(e);
                    }
                }}
            >
                <WidgetsList uids={bottomSheet?.uid} />
            </div>
        </ConditionalRender>
    );
};
export default FullScreenBottomSheet;
